import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCookie, setCookie } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { verifyAccessToken, loginAsUserFunc} from '../../redux/slices/protectSlice';
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const loginAdmin = createAsyncThunk(
  'adminAuth/loginAdmin',
  async (credentials, { dispatch, rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/login/admin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });

      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data);
      }

      localStorage.setItem('userId', data.data.user.id);
      localStorage.setItem('firstName', data.data.user.first_name);
      localStorage.setItem('lastName', data.data.user.last_name);
      localStorage.setItem('email', data.data.user.email);
      localStorage.setItem('accountType', data.data.user.account_type);

      if (data.data.user.super_admin == '1') {
        localStorage.setItem('486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese', data.data.user.super_admin);
      } else {
        localStorage.setItem('486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese', '0');
      }

      setCookie('accessToken', data.data.access_token, 30);
      
      if (verifyAccessToken) {
        dispatch(verifyAccessToken());
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const loginAsUser = createAsyncThunk(
  'adminAuth/loginAsUser',
  async (user_id, { rejectWithValue, dispatch }) => {  
    try {
      var p = {};
      p.id = user_id;
      const response = await fetch(`${BASE_URL}/admin/login-as-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p)
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data);
      }
      // Store user details and tokens 
      localStorage.setItem('firstName', data.data.user.first_name);
      localStorage.setItem('lastName', data.data.user.last_name);
      localStorage.setItem('email', data.data.user.email);
      localStorage.setItem('accountType', data.data.user.account_type);
      var currentAccessToken = getCookie('accessToken');
      setCookie('adminaccessToken', currentAccessToken, 30);
      setCookie('accessToken', data.data.access_token, 30);
      window.location.href = '/meal-plan';
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const loginAsAdmin = createAsyncThunk(
  'adminAuth/loginAsAdmin',
  async (user_id='', { rejectWithValue, dispatch }) => {
    try {
      var p = {};
      p.id = user_id;
      var accessToken = getCookie('adminaccessToken');
      const response = await fetch(`${BASE_URL}/admin/login-as-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+accessToken
        },
        body: JSON.stringify(p)
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data);
      }
      localStorage.setItem('486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese', data.data.user.super_admin);
      // Store user details and tokens 
      localStorage.setItem('firstName', data.data.user.first_name);
      localStorage.setItem('lastName', data.data.user.last_name);
      localStorage.setItem('email', data.data.user.email);
      localStorage.setItem('accountType', data.data.user.account_type);
      setCookie('accessToken', data.data.access_token, 30);


      if (data.data.user.super_admin == '1' && data.data.user.id != '1211') {
        window.location.href = '/admin/dashboard';
      } else {
        window.location.href = '/admin/users';
      }
      
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Define initial state
const initialState = {
  user: null,
  status: 'idle',
  error: null,
};

// Create slice for admin authentication
const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
    setLoggedInUser(state, action) {
      state.user = action.payload;
    },
    logout(state) {
      state.user = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAdmin.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload.data.user;
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload.message || action.payload;
      })
      .addCase(loginAsUser.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(loginAsUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload.data.user;
      })
      .addCase(loginAsUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload.message || action.payload;
      })
      .addCase(loginAsAdmin.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(loginAsAdmin.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload.data.user;
      })
      .addCase(loginAsAdmin.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload.message || action.payload;
      });
  },
});

export const { clearError, setLoggedInUser, logout } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;